// Điểm mở rộng của Tổng quan (FSD.md §2.1, §3.1): không có "Tạo mới" / Tìm nhanh / lớp phủ riêng ("Tạo dự án" mở lớp phủ
// projectForm của Nguồn hàng); thời gian thực làm mới số liệu gộp. Hộp việc (`inbox`) đã nối ở khung ứng dụng (inboxRealtime).
import { qk, type RealtimeBinding } from '@/shared/api';
import type { CreateItem } from '@/widgets/app-shell';

/** Không có mục "Tạo mới" (trang điều hành). */
export const createItems: CreateItem[] = [];

/**
 * Tin "đã đổi" của giao dịch (GTGD, cọc, phí — projection bất đồng bộ của performance), bảng hàng (căn trống / đang giữ, giỏ
 * hàng theo dự án) và chấm công (vào/ra ca, đi làm hôm nay) ⇒ tải lại GET /dashboard; gộp 5 s ở cạnh sau (giờ cao điểm mở
 * bán không dồn tải lên gateway, đủ thời gian cho projection).
 */
export const realtime: RealtimeBinding[] = [
  { topic: 'deals', module: 'dashboard', keys: () => [qk.dashboard.all], throttleMs: 5000 },
  { topic: 'booking.units', module: 'dashboard', keys: () => [qk.dashboard.all], throttleMs: 5000 },
  { topic: 'attendance', module: 'dashboard', keys: () => [qk.dashboard.all], throttleMs: 5000 },
];
